<div class="app-header" (click)="onAppHeaderClick($event)" *ngIf="landownerLandingPageMode == false">
  <nav class="main navbar navbar-expand-lg navbar-custom" [ngClass]="{ impersonating: isImpersonating }">
    <div class="container-fluid">
      <div class="navbar-header">
        <img
          id="logo-image"
          (click)="onHeaderLogoClick()"
          class="logo-image"
          src="../assets/images/oa-logo-orange_lg.png"
          alt="Outdoor Access"
        />
        <div class="mobile-only"><a routerLink="/aboutus">About</a></div>
        <div class="mobile-only"><a routerLink="/landowner/profit">List your land</a></div>

        <!-- This span is displayed only for mobile sized devices -->
        <span
          *ngIf="showCreditMenuItem"
          class="credit-amount-display credit-amount-display-mobile"
          title="{{ availableCreditMessage }}"
          (click)="onCreditLinkClick()"
        >
          ${{ credits.balance }}
        </span>

        <button type="button" class="navbar-toggle collapsed" (click)="navToggle = true">
          <span class="sr-only">Toggle navigation</span>
          <span class="icon-bar"></span>
          <span class="icon-bar"></span>
          <span class="icon-bar"></span>
        </button>

      </div>
      <div class="navbar-collapse collapse nav-align">
        <!-- These Items should always be visible regardless of login status -->
        <ul class="navbar-nav nav-align">
          <li>
            <a
              routerLink="/aboutus"
            >
              About</a
            >
          </li>
          
          <li>
            <a
              routerLink="/landowner/profit"
              id="app-header-list-land-non-member"
            >
              List your land</a
            >
          </li>
          <li *ngIf="(userService.isLoggedIn$ | async) && hasListing">
            <a routerLink="/landowner/listing">My Listings</a>
          </li>
          <ng-container *ngIf="showSearchListingButton">
            <li *ngIf="!isMember">
              <a
                routerLink="/newsearch/0/000"
                id="app-header-search-listings-non-member"
                class="app-header-search-listings"
              >
                Search Listings</a
              >
            </li>
            <li *ngIf="isMember">
              <button
                type="button"
                id="app-header-search-listings-member"
                class="btn btn-signin app-header-search-listings"
                routerLink="/newsearch/0/000"
              >
                Search Listings
              </button>
            </li>
          </ng-container>

          <li *ngIf="showClearActiveOrgButton">
            <button
              type="button"
              id="app-header-standard-oa-button"
              class="btn btn-signin app-header-search-listings"
              (click)="clearActiveOrg()"
            >
              Standard Outdoor Access
            </button>
          </li>

          <li class="dropdown" *ngIf="showOrganizationMenu">
            <a class="btn dropdown-btn dropdown-toggle" type="button" data-bs-toggle="dropdown" aria-expanded="false">
              Organizations
            </a>
            <ul class="dropdown-menu dropdown-menu-end">
              <li *ngFor="let code of externalOrgCodes">
                <a (click)="onOrgClick(code)">{{ code }}</a>
              </li>
            </ul>
          </li>

          <li *ngIf="showOrganizationButton">
            <button type="button" id="app-header-single-org-button" (click)="onOrgButtonClick()" class="btn btn-appheader">
              {{ externalOrgDescription }}
            </button>
          </li>
        
          <li>
            <a
              href="https://go.outdooraccess.com/products-list" target="_blank"
              id="app-header-store"
            >
              Online Store</a
            >
          </li>
          
          
          <li class="dropdown">
            <a class="btn dropdown-btn dropdown-toggle" type="button" data-bs-toggle="dropdown" aria-expanded="false" id="help-dropdown-menu">
              Help
            </a>
            <ul class="dropdown-menu dropdown-menu-end">
              <li>
                <a class="dropdown-item" [routerLink]="['/aboutus/help']">FAQ</a>
              </li>
              <li>
                <a class="dropdown-item" routerLink="/contact-us">Contact Us</a>
              </li>
            </ul>
          </li>
        </ul>

        <!-- Outdoor Access Administrator ('Admin') Menu *ngIf="(userService.isLoggedIn$ | async) && isAdmin" -->
        <ul class="navbar-nav" *ngIf="userService.isLoggedIn$ | async" >
          <li *ngIf="userService.isAdmin" class="dropdown">
            <a class="btn dropdown-btn dropdown-toggle" type="button" data-bs-toggle="dropdown" aria-expanded="false" id="admin-dropdown-menu">
              <i
                *ngIf="userService.isAdmin && adminNotifications && adminNotifications.length > 0"
                class="admin-notification-icon fa fa-warning blink"
                aria-hidden="true"
                (click)="onAdminNotificatonClick($event)"
              ></i>
              Admin
            </a>
            <ul class="dropdown-menu dropdown-menu-end" role="menu">
              <li>
                <a class="dropdown-item" id="admin-link-search" routerLink="/admin/search"><i class="fa fa-search"></i><span>Search</span></a>
              </li>

              <li>
                <a class="dropdown-item" id="admin-link-bookings" routerLink="/admin/bookings"><i class="fa fa-calendar-check"></i><span>Bookings</span></a>
              </li>

              <li>
                <a class="dropdown-item" id="admin-link-messages" routerLink="/admin/messages"><i class="fa fa-envelope"></i><span>Recent Messages</span></a>
              </li>

              <li>
                <a class="dropdown-item" id="admin-link-accounts" routerLink="/admin/accounts"><i class="fa fa-address-card"></i><span>Accounts</span></a>
              </li>

              <li>
                <a class="dropdown-item" id="admin-link-external-accounts" routerLink="/admin/accounts/external"
                  ><i class="fa-regular fa-address-card"></i><span>External Accounts</span></a
                >
              </li>

              <li>
                <a class="dropdown-item" id="admin-link-background-checks" routerLink="/admin/bcg"
                  ><i class="fa fa-check-circle"></i><span>Background Checks</span></a
                >
              </li>
              <li>
                <a class="dropdown-item" id="admin-link-listings" routerLink="/admin/listings-new"><i class="fa fa-table"></i><span>Listings</span></a>
              </li>
              <li>
                <a class="dropdown-item" id="admin-link-lead-contacts" routerLink="/admin/contacts"
                  ><i class="fa fa-users" aria-hidden="true"></i> Contacts/Leads</a
                >
              </li>
              <li>
                <a class="dropdown-item" id="admin-link-data-download" routerLink="/admin/data-download"
                  ><i class="fa fa-cloud-download"></i><span>Data Download</span></a
                >
              </li>
              <li>
                <a class="dropdown-item" id="admin-link-work-tasks" routerLink="/admin/work-tasks"><i class="fa fa-tasks"></i><span>Work Tasks</span></a>
              </li>

              <li>
                <a class="dropdown-item" id="admin-link-reservations" routerLink="/admin/reservations"><i class="fa fa-calendar"></i><span>Reservations</span></a>
              </li>

              <li>
                <a class="dropdown-item" id="admin-link-scout" routerLink="/admin/scout"
                  ><i class="fa fa-binoculars"></i><span title="Added 2020-03">Scouting Days</span></a
                >
              </li>

              <li>
                <a class="dropdown-item" id="admin-link-waiting-list" routerLink="/admin/waiting-list"
                  ><i class="fa fa-list-alt"></i><span title="Added 2019-11">Waiting List</span></a
                >
              </li>

              <li>
                <a class="dropdown-item" id="admin-link-permits" routerLink="/admin/permits"><i class="fa fa-file"></i><span>Permits</span></a>
              </li>

              <li>
                <a class="dropdown-item" id="admin-link-seasonal-leases" routerLink="/admin/seasonal-leases"
                  ><i class="fa fa-calendar fa-seasonal-lease"></i><span>Seasonal {{ "Rental" | lexicalVariable }}</span></a
                >
              </li>
              <li>
                <a class="dropdown-item" routerLink="/admin/reviews"><i class="fa fa-file-text"></i><span>Reviews</span></a>
              </li>
              <li>
                <a class="dropdown-item" id="admin-link-discounts" routerLink="/admin/advertising"
                  ><i class="fa-regular fa-dollar-sign"></i><span> Discounts and Promotions</span></a
                >
              </li>

              <li *ngIf="adminStoreUrl">
                <a [href]="adminStoreUrl"> <i class="fa fa-dollar" target="_blank"></i> <span>Store Admin</span></a>
              </li>

              <li *ngIf="storeOrdersUrl">
                <a [href]="storeOrdersUrl"> <i class="fa fa-list-ul" target="_blank"></i> <span>Store Orders</span></a>
              </li>

              <li class="dropdown-divider"></li>
              <li>
                <a class="dropdown-item" href="{{malibuUrl}}" target="malibu">Malibu</a>
              </li>
              <li>
                <a class="dropdown-item" id="admin-link-malibu" routerLink="/admin/listing-query-summary">Listing Query Request Summary</a>
              </li>

              <li class="dropdown-divider"></li>
              <li>
                <a class="dropdown-item" id="admin-link-error-log" routerLink="/admin/errorlog"><i class="fa fa-exclamation-circle"></i><span>Error Log</span></a>
              </li>

              <li>
                <a class="dropdown-item" id="admin-link-settings" routerLink="/admin/appsettings"><i class="fa fa-cog"></i><span>Settings</span></a>
              </li>

              <li class="dropdown-divider"></li>

              <li>
                <a class="dropdown-item" id="admin-link-control-panel" routerLink="admin/cp">Control Panel</a>
              </li>
            </ul>
          </li>

          <li *ngIf="showCreditMenuItem" style="margin: auto 0 ;">
            <a title="{{ availableCreditMessage }}" class="link credit-amount-display" (click)="onCreditLinkClick()"
              >${{ credits.balance }}</a
            >
          </li>

          <li class="dropdown">
            <a class="btn dropdown-btn dropdown-toggle" type="button" data-bs-toggle="dropdown" aria-expanded="false" id="user-dropdown-menu">
              
              {{ userProfile?.firstName || "My Account" }}

            </a>
            <ul class="dropdown-menu dropdown-menu-end">
              <li>
                <a class="dropdown-item" id="account-info-menu-item-desktop" routerLink="/user/profile">Account Info</a>
              </li>

              <li *ngIf="showAmbassadorMenuItem">
                <a class="dropdown-item" id="ambassador-menu-item-desktop" routerLink="/ambassador">Ambassador</a>
              </li>

              <li *ngIf="!isMember">
                <a class="dropdown-item" id="become-a-member-menu-item-desktop"  routerLink="/user/membership-plans">Become a Member</a>
              </li>
              <li>
                <a  class="dropdown-item" id="my-leases-menu-item-desktop" routerLink="/user/trips/upcoming">{{myTripLeaseLabel.plural}}</a>
              </li>
              <li>
                <a class="dropdown-item" routerLink="/user/permits">My Permits</a>
              </li>

              <li *ngIf="userService.isLoggedIn$ | async">
                <a class="dropdown-item" routerLink="/user/favorites">My Favorites</a>
              </li>

              <li>
                <a class="dropdown-item" routerLink="/user/reviews">My Reviews</a>
              </li>

              <ng-container *ngIf="showRecentMenuItem">
                <li class="dropdown-divider"></li>
                <li>
                  <a class="dropdown-item" routerLink="/user/recent">Recent</a>
                </li>
              </ng-container>
              <li class="dropdown-divider"></li>
              <li *ngIf="!hasListing" class="dropdown">
                <a class="dropdown-item" [routerLink]="['/landowner/profit']" target="_blank">List My Land</a>
              </li>
              <li *ngIf="hasListing">
                <a class="dropdown-item" id="my-listings-link" routerLink="/landowner/listing">My Listings</a>
              </li>
              <li *ngIf="hasListing">
                <a class="dropdown-item" routerLink="/landowner/bookings">My Bookings</a>
              </li>
              <li class="dropdown-divider"></li>
              <li>
                <a class="dropdown-item" id="logout-menu-item" (click)="logout()">Logout</a>
              </li>
            </ul>
          </li>
        </ul>
        <ul class="navbar-nav">
          <li *ngIf="showBecomeMemberButton">
            <button
              type="button"
              class="btn btn-signin"
              routerLink="user/membership-plans"
              id="app-header-become-member-button"
            >
              Become a Member!
            </button>
          </li>
        </ul>
        <ul *ngIf="!(userService.isLoggedIn$ | async)" class="navbar-nav">
          <li>
            <!-- Top-Level Menu in App Header -->
            <a id="app-header-signin-button" (click)="login()">Sign Up / Sign In</a>
          </li>
        </ul>
      </div>
      <!--/.nav-collapse -->
    </div>
  </nav>
  <!--/.container-fluid -->

  <!-- ambassador -->
  <div class="side-menu-wrapper">
    <div class="side-menu-container" [class.active]="navToggle === true">
      <div class="side-menu">
        <div class="btn-toggle-close">
          <a (click)="navToggle = false">
            <i class="fa fa-times fa-2x" aria-hidden="true"></i>
          </a>
        </div>
        <ul (click)="navToggle = false">
          <ng-container *ngIf="showSearchListingButton">
            <li class="dropdown-divider"></li>
            <li>
              <a routerLink="/newsearch/0/000">Search Listings</a>
            </li>
          </ng-container>

          <ng-container *ngIf="showClearActiveOrgButton">
            <li class="dropdown-divider"></li>
            <li>
              <a (click)="clearActiveOrg()">Standard Outdoor Access</a>
            </li>
          </ng-container>

          <ng-container *ngIf="showOrganizationButton">
            <li class="dropdown-divider"></li>
            <li>
              <a (click)="onOrgButtonClick()">{{ externalOrgDescription }}</a>
            </li>
          </ng-container>

          <ng-container *ngIf="showOrganizationMenu">
            <li class="dropdown-divider"></li>
            <li>
              <a (click)="onOrgClick('DWR')">DWR Home</a>
            </li>
          </ng-container>

          <li class="dropdown-divider"></li>

          <li *ngIf="!(userService.isLoggedIn$ | async)">
            <a style="font-weight: bold" (click)="login()">Sign Up / Sign In</a>
          </li>

          <li *ngIf="showAmbassadorMenuItem">
            <a id="ambassador-menu-item-mobile" routerLink="/ambassador">Ambassador</a>
          </li>

          <li *ngIf="userService.isLoggedIn$ | async">
            <a id="my-leases-menu-item-mobile" routerLink="/user/trips/upcoming">{{myTripLeaseLabel.plural}}</a>
          </li>
          <li *ngIf="userService.isLoggedIn$ | async">
            <a routerLink="/user/permits">My Permits</a>
          </li>

          <li *ngIf="userService.isLoggedIn$ | async">
            <a routerLink="/user/favorites">My Favorites</a>
          </li>

          <li *ngIf="userService.isLoggedIn$ | async">
            <a id="my-account-menu-item" routerLink="/user/profile">My Account</a>
          </li>
          <li *ngIf="userService.isLoggedIn$ | async">
            <a routerLink="/user/reviews">My Reviews</a>
          </li>
          <li class="dropdown-divider"></li>
          <li *ngIf="!(userService.isLoggedIn$ | async) || !hasListing">
            <a [routerLink]="['/landowner/profit']">List My Land</a>
          </li>
          <li *ngIf="(userService.isLoggedIn$ | async) && hasListing">
            <a routerLink="/landowner/listing">My Listings</a>
          </li>
          <li *ngIf="(userService.isLoggedIn$ | async) && hasListing">
            <a routerLink="/landowner/bookings">My Bookings</a>
          </li>
          <li class="dropdown-divider"></li>
          <li>
            <a (click)="onStoreLinkClick('https://go.outdooraccess.com/products-list')">OA Gear Store</a>
          </li>
          <li *ngIf="!(userService.isLoggedIn$ | async) || !isMember">
            <a [routerLink]="['/aboutus/news']">News</a>
          </li>
          <li>
            <a [routerLink]="['/contact-us']">Contact Us</a>
          </li>
          <li *ngIf="!(userService.isLoggedIn$ | async) || !isMember">
            <a [routerLink]="['/aboutus/testimonial']"> Testimonials</a>
          </li>
          <!-- <li *ngIf="!(userService.isLoggedIn$ | async) || !isMember">
            <a [routerLink]="['/aboutus/welcome']">Welcome Letter</a>
          </li> -->
          <!-- <li *ngIf="!(userService.isLoggedIn$ | async) || !isMember">
            <a [routerLink]="['/aboutus/team']">Meet the Team</a>
          </li> -->
          <li>
            <a [routerLink]="['/aboutus/help']">Help</a>
          </li>
          <li *ngIf="showSendLocation">
            <a *ngIf="canGeolocate" (click)="onSendLocationClick()">Send OA My Location</a>
          </li>
          <li *ngIf="userService.isLoggedIn$ | async" class="dropdown-divider"></li>
          <li *ngIf="userService.isLoggedIn$ | async">
            <a id="logout-menu-item-mobile" (click)="logout()">Logout</a>
          </li>
        </ul>
      </div>
    </div>
  </div>
</div>

